import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, takeUntil, take } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i2 from 'bulk-upload-dashboard';
import * as i3 from 'custom-button-action';
import { PrimengLibraryModule } from 'primeng-library';

class ViewCandidateDetailsService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getCandidateDetails(candidateId, applicantClientJobPositionsId) {
        const params = {};
        if (applicantClientJobPositionsId !== null && applicantClientJobPositionsId !== undefined) {
            params.applicantClientJobPositionsId = applicantClientJobPositionsId.toString();
        }
        return this.http.get(`/vd/formBuilder/get/applicant/${candidateId}/info`, { params }).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
ViewCandidateDetailsService.ɵfac = function ViewCandidateDetailsService_Factory(t) { return new (t || ViewCandidateDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
ViewCandidateDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: ViewCandidateDetailsService, factory: ViewCandidateDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewCandidateDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class ViewCandidateDetailsComponent {
    constructor(viewCandidateDetailsService, bulkUploadDashboardService, customButtonActionService) {
        this.viewCandidateDetailsService = viewCandidateDetailsService;
        this.bulkUploadDashboardService = bulkUploadDashboardService;
        this.customButtonActionService = customButtonActionService;
        this.observableSubscription$ = new Subject();
        this.getViewCandidateResume = [];
    }
    ngOnInit() {
        this.getLeaveSummaryDetails();
    }
    getLatestRowID() {
        const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO'));
        return fbFormDataDTO[fbFormDataDTO.length - 1].id;
    }
    getLeaveSummaryDetails() {
        this.candidateId = 'applicantId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantId')) : 'fbFormDataDTO' in sessionStorage ? this.getLatestRowID() : null;
        this.applicantInfoId = 'applicantInfoId' in sessionStorage ? parseInt(sessionStorage.getItem('applicantInfoId')) : null;
        if (this.candidateId) {
            this.viewCandidateDetailsService.getCandidateDetails(this.candidateId, this.applicantInfoId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                this.viewCandidateDetails = response.data || null;
                if (((_c = (_b = (_a = this.viewCandidateDetails) === null || _a === void 0 ? void 0 : _a.applicantInfo) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.length) >= 1) {
                    for (let file of (_e = (_d = this.viewCandidateDetails) === null || _d === void 0 ? void 0 : _d.applicantInfo) === null || _e === void 0 ? void 0 : _e.file) {
                        this.getViewCandidateResume.push(file);
                    }
                }
                else {
                    this.fileName = ((_h = (_g = (_f = this.viewCandidateDetails) === null || _f === void 0 ? void 0 : _f.applicantInfo) === null || _g === void 0 ? void 0 : _g.file) === null || _h === void 0 ? void 0 : _h.fileName) ? (_l = (_k = (_j = this.viewCandidateDetails) === null || _j === void 0 ? void 0 : _j.applicantInfo) === null || _k === void 0 ? void 0 : _k.file[0]) === null || _l === void 0 ? void 0 : _l.fileName : "N/A";
                }
            });
        }
    }
    backToParentPage() {
        var pageFormId = JSON.parse(sessionStorage.getItem("selectedMenu"));
        pageFormId = pageFormId.pageFormId;
        if (pageFormId) {
            this.customButtonActionService.getPageFormById(pageFormId)
                .pipe(take(1)).subscribe((response) => {
                if (response) {
                    const item = {
                        formType: response.buildFormatTypeId,
                        pageFormId: response.id
                    };
                    this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                }
            });
        }
    }
    talentedit() {
        this.bulkUploadDashboardService.editFlowflag = 'view_candidate';
        const item = {
            formType: 1482,
            pageFormId: 276
        };
        this.customButtonActionService.onLinkRedirectPageSubject.next(item);
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        sessionStorage.setItem("currentPageFormId", sessionStorage.getItem('pageFormId'));
    }
}
ViewCandidateDetailsComponent.ɵfac = function ViewCandidateDetailsComponent_Factory(t) { return new (t || ViewCandidateDetailsComponent)(i0.ɵɵdirectiveInject(ViewCandidateDetailsService), i0.ɵɵdirectiveInject(i2.BulkUploadDashboardService), i0.ɵɵdirectiveInject(i3.CustomButtonActionService)); };
ViewCandidateDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ViewCandidateDetailsComponent, selectors: [["view-candidate-details"]], decls: 46, vars: 7, consts: [[1, "container-fluid", "view_candidate_summary", "p-0", "m-0", "mt-2"], [1, "row"], [1, "col-6", "pl-0"], [1, "col-2"], [1, "back-button", "d-inline-flex", "pl-2", "pr-2", "align-items-center", "mb-3", "talent_edit", 3, "click"], ["aria-hidden", "true", 1, "fa", "fa-chevron-circle-left", "pr-1"], [1, "col-12"], [1, "col-6", "text-right"], [1, "talent_edit", "back-button", "d-inline-flex", "align-items-center", "pr-3", "pl-3", "mr-3", 3, "click"], [1, "col-3"], [1, "view_candidate_details_heading"], [1, "view_candidate_details_content"], [1, "row", "mb-3"]], template: function ViewCandidateDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "button", 4);
        i0.ɵɵlistener("click", function ViewCandidateDetailsComponent_Template_button_click_5_listener() { return ctx.backToParentPage(); });
        i0.ɵɵelement(6, "i", 5);
        i0.ɵɵtext(7, " Back ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 6);
        i0.ɵɵelementStart(9, "h5");
        i0.ɵɵtext(10, "Basic Details");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 7);
        i0.ɵɵelementStart(12, "button", 8);
        i0.ɵɵlistener("click", function ViewCandidateDetailsComponent_Template_button_click_12_listener() { return ctx.talentedit(); });
        i0.ɵɵtext(13, " Edit ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 1);
        i0.ɵɵelementStart(15, "div", 9);
        i0.ɵɵelementStart(16, "p", 10);
        i0.ɵɵtext(17, " Name ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "p", 11);
        i0.ɵɵtext(19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 9);
        i0.ɵɵelementStart(21, "p", 10);
        i0.ɵɵtext(22, " Current Position ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "p", 11);
        i0.ɵɵtext(24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 9);
        i0.ɵɵelementStart(26, "p", 10);
        i0.ɵɵtext(27, " Designation ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "p", 11);
        i0.ɵɵtext(29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 9);
        i0.ɵɵelementStart(31, "p", 10);
        i0.ɵɵtext(32, " Experience ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "p", 11);
        i0.ɵɵtext(34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 12);
        i0.ɵɵelementStart(36, "div", 9);
        i0.ɵɵelementStart(37, "p", 10);
        i0.ɵɵtext(38, " Location ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "p", 11);
        i0.ɵɵtext(40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 9);
        i0.ɵɵelementStart(42, "p", 10);
        i0.ɵɵtext(43, " Source ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "p", 11);
        i0.ɵɵtext(45);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(19);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.applicantInfo == null ? null : ctx.viewCandidateDetails.applicantInfo.firstName) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.applicantInfo == null ? null : ctx.viewCandidateDetails.applicantInfo.firstName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].designation) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].designation : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].designation) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].designation : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate2(" ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].totalExperienceInYears) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].totalExperienceInYears : "--", " Years ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].totalExperienceInMonths) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.employmentList[0] == null ? null : ctx.viewCandidateDetails.employmentList[0].totalExperienceInMonths : "--", " Months ");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.applicantInfo == null ? null : ctx.viewCandidateDetails.applicantInfo.stateProvinceName) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.applicantInfo == null ? null : ctx.viewCandidateDetails.applicantInfo.stateProvinceName : "--", " ");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", (ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.applicantInfo == null ? null : ctx.viewCandidateDetails.applicantInfo.sourceName) ? ctx.viewCandidateDetails == null ? null : ctx.viewCandidateDetails.applicantInfo == null ? null : ctx.viewCandidateDetails.applicantInfo.sourceName : "--", " ");
    } }, styles: [".view_candidate_summary[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#6d6d6d;font-weight:600}.view_candidate_summary[_ngcontent-%COMP%]   .view_candidate_details_heading[_ngcontent-%COMP%]{font-size:14px;margin-bottom:0}.view_candidate_summary[_ngcontent-%COMP%]   .view_candidate_details_content[_ngcontent-%COMP%]{font-weight:600}.view_candidate_summary[_ngcontent-%COMP%]   .pdf_section[_ngcontent-%COMP%]{border-top:2px dashed #ccc;padding-top:30px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewCandidateDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'view-candidate-details',
                templateUrl: 'view-candidate-details.component.html',
                styleUrls: ['view-candidate-details.component.scss']
            }]
    }], function () { return [{ type: ViewCandidateDetailsService }, { type: i2.BulkUploadDashboardService }, { type: i3.CustomButtonActionService }]; }, null); })();

class ViewCandidateDetailsModule {
}
ViewCandidateDetailsModule.ɵfac = function ViewCandidateDetailsModule_Factory(t) { return new (t || ViewCandidateDetailsModule)(); };
ViewCandidateDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: ViewCandidateDetailsModule });
ViewCandidateDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ViewCandidateDetailsModule, { declarations: [ViewCandidateDetailsComponent], imports: [PrimengLibraryModule], exports: [ViewCandidateDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ViewCandidateDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [ViewCandidateDetailsComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [ViewCandidateDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of view-candidate-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ViewCandidateDetailsComponent, ViewCandidateDetailsModule, ViewCandidateDetailsService };
//# sourceMappingURL=view-candidate-details.js.map
